<script setup lang="ts">
// Store
import { useDeliveryStore } from '@/store/delivery/delivery'
import { useAppStore } from '@/store/app/app'

/* Components */
import IconDeliveryArrowMarker from '@/components/Icons/IconDeliveryArrowMarker.vue'

import { StateOfAutocomplete } from '@/constants/components/autocomplete'

/* Types */
import { PlacesSearch } from '@/store/delivery/delivery.types'
import { ServerError, Success } from '@/api/results'

const emits = defineEmits(['setAutocompleteError'])

const myPositionIsLoading = ref(false)
const isDisabledButton = shallowRef(true)

const { $sentryCaptureException } = useNuxtApp()

const { showSnackbar } = useAppStore()
const deliveryStore = useDeliveryStore()

onMounted(() => {
  if (navigator.geolocation) isDisabledButton.value = !isDisabledButton
})

// Запрашиваем геопозицию клиента
const getMyPosition = (): any => {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Геолокация не поддеживается вашим браузером'))
    }
    navigator.geolocation.getCurrentPosition(resolve, reject)
  })
}

// Получаем геопозицию клиента
const geolocationClickHandler = async () => {
  myPositionIsLoading.value = true

  try {
    const { coords } = await getMyPosition()

    const { latitude, longitude } = coords

    const { $apiService } = useNuxtApp()

    const result = await $apiService.geocode.getAddressByCoordinates([
      latitude,
      longitude,
    ])

    if (result instanceof ServerError) {
      emits('setAutocompleteError', StateOfAutocomplete.NOT_DETECTED)

      return
    }

    const address = result instanceof Success ? result.data : null

    // Передаем autocomplete, т.к нужно обновить состояние других компонентов
    deliveryStore.setDeliverySearch(PlacesSearch.AUTOCOMPLETE, address)
  } catch (error) {
    const errorMessage =
      error.code === 1
        ? StateOfAutocomplete.BAN_GEO
        : StateOfAutocomplete.NOT_DETECTED

    showSnackbar({ message: errorMessage })

    $sentryCaptureException(error)
  }

  myPositionIsLoading.value = false
}
</script>

<template>
  <v-btn
    variant="text"
    :loading="myPositionIsLoading"
    :disabled="isDisabledButton"
    class="search-button"
    type="submit"
    color="#ff5044"
    @click="geolocationClickHandler"
  >
    <icon-delivery-arrow-marker
      class="search-button__arrow-marker"
      color="#ff5044"
    />
  </v-btn>
</template>

<style lang="scss" scoped>
.search-button {
  height: 48px !important;
  padding: 0;
  margin-left: 16px;
  background: $white;
  border-radius: 12.5px;
  box-shadow: 0 5px 25px rgba(65, 58, 91, 0.15);

  &.v-btn--disabled {
    color: $secondary !important;
  }
}
</style>
